import { render } from "./ItemSelecao.vue?vue&type=template&id=0a658ac8&scoped=true"
import script from "./ItemSelecao.vue?vue&type=script&lang=js"
export * from "./ItemSelecao.vue?vue&type=script&lang=js"

import "./ItemSelecao.vue?vue&type=style&index=0&id=0a658ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a658ac8"]])

export default __exports__